<template>
    <li>
        <div class="logo_img" @click="goAuthor(dataLi.detail_display_userid)">
            <img :src="dataLi.logo_path | logo_show('', $store.state.static_img_url + 'pic/vcbeat/no_face.jpg')" />
        </div>
        <div class="entity_info">
            <p class="p1 clear">
              <span
                  class="span_name"
                  @click="goAuthor(dataLi.detail_display_userid)"
              >{{dataLi.name}}</span>
            </p>
            <p class="p2">共发表{{dataLi.num}}篇文章</p>
        </div>
        <div class="entity_chk">
            <span class="sp1" @click="goAuthor(dataLi.detail_display_userid)">查看</span>
        </div>
    </li>
</template>
<script>
export default {
    props: ['dataLi'],
    methods: {
        goAuthor(uid) {
            window.open(this.$store.state.index2_path + '/Article/authorArticle/keyword/'+uid)
        }
    }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/searchEntity.stylus'
.logo_img {
    border-radius 50%
}
.sp1 {
    color #FA5A00
    cursor pointer
}
</style>